<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <mat-dialog-content fxLayout="column" fxLayoutAlign="start" class="p-24">
        <ng-container *ngIf="!isLoading; else shimmer">
            <mat-tab-group class="border border-gray-200">
                <mat-tab>
                    <ng-template mat-tab-label> {{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.USERS_CREATED' | translate }} ({{ this.nbrUsersCreated }}) </ng-template>

                    <div *ngIf="nbrUsersCreated; else noCreatedUsers">
                        <table mat-table [dataSource]="dataSourceCreatedUsers" class="mat-elevation-z8 w-100-p">
                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.EMAIL' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
                            </ng-container>

                            <ng-container matColumnDef="firstName">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.FIRSTNAME' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
                            </ng-container>

                            <ng-container matColumnDef="lastName">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.LASTNAME' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
                            </ng-container>

                            <ng-container matColumnDef="language">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.LANGUAGE' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.language }}</td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
                    </div>

                    <ng-template #noCreatedUsers>
                        <div class="no-results-container my-48" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="participant-view-illustration" svgIcon="opened_folder"></mat-icon>
                            <h2 class="mt-8">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
                        </div>
                    </ng-template>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label> {{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.USERS_DUPLICATES' | translate }} ({{ this.nbrUsersDuplicated }}) </ng-template>

                    <div *ngIf="nbrUsersDuplicated; else noDuplicatesUsers">
                        <table mat-table [dataSource]="dataSourceDuplicatedUsers" class="mat-elevation-z8 w-100-p">
                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.EMAIL' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
                            </ng-container>

                            <ng-container matColumnDef="firstName">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.FIRSTNAME' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
                            </ng-container>

                            <ng-container matColumnDef="lastName">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.LASTNAME' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
                            </ng-container>

                            <ng-container matColumnDef="language">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.LANGUAGE' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.language }}</td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
                    </div>

                    <ng-template #noDuplicatesUsers>
                        <div class="no-results-container my-48" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="participant-view-illustration" svgIcon="opened_folder"></mat-icon>
                            <h2 class="mt-8">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
                        </div>
                    </ng-template>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label> {{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.MODULES' | translate }} ({{ this.nbrModules }}) </ng-template>

                    <div *ngIf="nbrModules; else noModules">
                        <table mat-table [dataSource]="dataSourceModules" class="w-100-p">
                            <ng-container matColumnDef="moduleName">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.MODULE_NAME' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.moduleName }}</td>
                            </ng-container>

                            <ng-container matColumnDef="newlyAssigned">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.NEWLY_ASSIGNED' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.newlyAssigned }}</td>
                            </ng-container>

                            <ng-container matColumnDef="alreadyAssigned">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.ALREADY_ASSIGNED' | translate }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.alreadyAssigned }}</td>
                            </ng-container>

                            <ng-container matColumnDef="assignmentFailed">
                                <th mat-header-cell *matHeaderCellDef>{{ 'PAGE.DIALOG.DETAILS_IMPORT_USERS.USERS.TAB.ASSIGNMENT_FAILED' | translate }}</th>
                                <td mat-cell *matCellDef="let element">
                                    <span matTooltip="{{ 'ERROR.RESPONSE' + element.error | translate }}" aria-label="Display errors">
                                        {{ element.assignmentFailed }}
                                    </span>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedModuleColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedModuleColumns"></tr>
                        </table>
                    </div>

                    <ng-template #noModules>
                        <div class="no-results-container my-48" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="participant-view-illustration" svgIcon="opened_folder"></mat-icon>
                            <h2 class="mt-8">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
                        </div>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </ng-container>

        <ng-template #shimmer>
            <div class="shimmer-container min-w-full">
                <div class="shimmer">
                    <div class="shimmer-card table animate"></div>
                </div>
            </div>
        </ng-template>
    </mat-dialog-content>
</mat-dialog-content>
